import {requirePermission} from '@/modules/auth/permissions'
import {DrugsCategoryForm} from '@/modules/basic-data/categories/components'
import {NewDrugsCategoryPageSearchSchema} from '@/modules/basic-data/categories/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/basic-data/categories/new')({
  beforeLoad: requirePermission('basic_data.manage'),
  component: NewCategoryPage,
  validateSearch: NewDrugsCategoryPageSearchSchema,
})

function NewCategoryPage() {
  const {t} = useTranslate('categories')
  const {categoryId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={categoryId ? t('edit_category_title') : t('new_category_title')}
        description={t('new_category_description')}
      />

      <DrugsCategoryForm categoryId={categoryId} />
    </NewResourceFormContainer>
  )
}
